import { unmask } from '@/components/telephone/telephoneUtil';

export function nettoyageTelephone(form) {
  const pm = JSON.parse(JSON.stringify(form));
  pm.fax = unmask(pm.fax);

  pm.telephones.forEach(telephone => {
    telephone.numero = unmask(telephone.numero);
  });

  return pm;
}
